import React, { FC } from 'react';
import useDetectClickOutside from '../../../../../packages/hooks/useDetectClickOutside';
import { SMPArrowDownIcon } from '@velinsi/smp-widgets-ui/src/atoms/icons/SMPArrowDownIcon';
import { MobileModal } from '@velinsi/smp-widgets-ui/src/molecules/MobileModal';
import { SMPContainer, SMPFlex, SMPText } from '@velinsi/smp-widgets-ui';
import { Languages } from '../../main';
import { isSameDate } from './MultisportDropdowns';

interface DatesDropdownProps {
  selectedOption: Date;
  options: Date[];
  handleChange: (option: Date) => void;
  closeDropdown: () => void;
  localeLang: Languages;
}

const HOUR_FORMAT: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' };

const MobileDatesDropdown: FC<DatesDropdownProps> = ({ handleChange, selectedOption, options, closeDropdown, localeLang }) => {
  const { isComponentVisible, setIsComponentVisible, ref } = useDetectClickOutside<HTMLDivElement>(true);
  const toggleDropdown = () => setIsComponentVisible((prevValue) => !prevValue);

  const handleOptionClick = (option: Date) => {
    handleChange(option);
    toggleDropdown();
  };

  return (
    <SMPContainer
      ref={ref}
      style={{
        margin: 0,
        padding: 0,
        width: '100%',
        borderRadius: '6px',
        position: 'relative',
      }}
    >
      <SMPFlex
        onClick={toggleDropdown}
        style={{
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          position: 'relative',
          padding: '12px 9px',
          color: 'var(--colors-hiContrast)',
          cursor: 'pointer',
          fontWeight: 'bold',
          lineHeight: '20px',
          border: '1px solid',
          backgroundColor: 'var(--colors-pillBackgroundColor)',
          borderRadius: '6px',
          borderColor: isComponentVisible ? 'var(--colors-multisportHighlightColor)' : 'var(--colors-dropdownBorderColor)',
        }}
      >
        <SMPText
          style={{
            height: '100%',
            color: 'var(--colors-hiContrast)',
            fontWeight: 'bold',
            fontFamily: 'var(--colors-primaryFontFamily)',
            fontSize: '14px',
            lineHeight: '20px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {selectedOption.toLocaleDateString(localeLang, HOUR_FORMAT)}
        </SMPText>
        <SMPArrowDownIcon
          style={{
            color: isComponentVisible ? 'var(--colors-multisportHighlightColor)' : 'var(--colors-selectButtonSecondaryColor)',
            transform: isComponentVisible ? 'rotate(180deg)' : 'unset',
          }}
        />
      </SMPFlex>

      <MobileModal
        isOpen={isComponentVisible}
        onClose={() => {
          setIsComponentVisible(false);
          closeDropdown();
        }}
      >
        {options.map((option, index) => (
          <SMPText
            style={{
              lineHeight: '20px',
              fontWeight: 'bold',
              fontSize: '14px',
              color: isSameDate(option, selectedOption) ? 'var(--colors-multisportHighlightColor)' : 'var(--colors-multiSportTextColor)',
              padding: '16px',
              width: '100%',
              borderBottom: '1px solid var(--colors-dropdownBorderColor)',
              backgroundColor: 'var(--colors-multiSportBgColor)',
            }}
            key={index}
            onClick={() => handleOptionClick(option)}
          >
            {option.toLocaleDateString(localeLang, HOUR_FORMAT)}
          </SMPText>
        ))}
      </MobileModal>
    </SMPContainer>
  );
};

export default MobileDatesDropdown;
